import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'

export default function KayitOl()
{
    const title = "OKAF Kayıt Ol - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'a kayıt olmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Kayıt Ol"></PageTitle>
            <div class="container">
                <div class="row kayitOl my-4">
                    <div class="col-md-6">
                        <div class="firma">
                            <div class="title">
                                <span><i class="bi bi-buildings-fill"></i>Firma / Kurum</span>
                                <div class="tire"></div>
                            </div>
                            <div class="uyari">
                                <p><strong><a href="https://yetenekkapisi.org/" target="_blank">yetenekkapisi.org<i class="bi bi-link-45deg"></i></a></strong> adresinden sisteme kayıt olunuz.</p>
                                <p>Soldaki menüden bağlantı kurmak istediğiniz üniversiteleri seçip istek gönderiniz.</p>
                            </div>
                            <ul>
                                <li>İstek gönderdikten sonra Orta Karadeniz Kariyer Fuarı OKAF 2023'e ev sahibi üniversite tarafından ekleneceksiniz.</li>
                                <li>Fuara eklendikten sonra sisteme girdiğinizde soldaki menüden <strong>'Kariyer Fuarı'</strong> sekmesine tıklayınız.</li>
                                <li>Açılan 'Kariyer Fuarları' sayfasında, <strong>'İstekler'</strong> butonuna tıklayarak size gelen kariyer fuarları isteklerini görüntüleyebilirsiniz ve <strong>'Eylemler'</strong> başlığı altındaki 'Onayla' butonuna tıklayarak istediğiniz fuarları onaylayabilirsiniz.</li>
                                <li>'Kariyer Fuarı' sekmesinden <strong>'Etkinlik Ekle'</strong> butonuna tıklayarak fuarda düzenleyeceğiniz etkinlik bilgilerini girebilirsiniz.</li>
                                <li>Fuarla ilgili katılımcı firma/kurum, katılacak öğrenci vs. bilgilerine erişim sağlayabileceksiniz.</li>
                                <li>Kariyer Fuarları haricinde de Yetenek Kapısı platformundan faydalanabileceksiniz.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="ogrenci">
                            <div class="title">
                                <span><i class="bi bi-person-fill"></i>Öğrenci</span>
                                <div class="tire"></div>
                            </div>
                            <div class="uyari">
                                <strong><a href="https://yetenekkapisi.org/" target="_blank">yetenekkapisi.org<i class="bi bi-link-45deg"></i></a></strong> adresinden sisteme kayıt olunuz.
                            </div>
                            <ul>
                                <li>Yetenek kapısı platformundan gelen e-postadaki aktivasyon bağlantısına mutlaka tıklayınız.</li>
                                <li>Kaydolduktan sonra <strong>yetenekkapisi.org</strong> adresinden giriş yapınız.</li>
                                <li>Soldaki menüden <strong>'Kariyer Fuarları'</strong> sekmesine tıklayınız.</li>
                                <li>Orta Karadeniz Kariyer Fuarı (OKAF) başlığı altında yer alan "Detaylı İncele" menüsüne tıklayınız.</li>
                                <li>Açılan sayfada en altta bulunan <strong>"Fuara Başvur"</strong> butonuna tıklayınız. Fuara başvurunuz tamamlanmış olacaktır.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
